/**
 * 🎯 EXECUTIVE WIDGET RENDERER
 * ════════════════════════════════════════════════════════════════════════
 * 
 * RESPONSABILIDAD:
 * Switch simple de tipo → componente.
 * 
 * REGLAS:
 * - NO lógica de layout (eso es del Grid)
 * - NO transformaciones de datos
 * - NO decisiones de orden
 * - Solo mapear type → React component
 */

import React from 'react';
import type { ExecutiveWidget } from '../types';
import HeroMetricWidget from '../widgets/HeroMetricWidget';
import BarChartWidget from '../widgets/BarChartWidget';
import LineChartWidget from '../widgets/LineChartWidget';
import TableWidget from '../widgets/TableWidget';

interface ExecutiveWidgetRendererProps {
  widget: ExecutiveWidget;
  index: number;  // Para detectar PRIMARY (posición 0)
}

const ExecutiveWidgetRenderer: React.FC<ExecutiveWidgetRendererProps> = ({ widget, index }) => {
  
  // PRIMARY_INSIGHT = primer widget + tipo metric
  const isPrimary = index === 0 && widget.type === 'metric';
  
  switch (widget.type) {
    case 'metric':
      return isPrimary 
        ? <HeroMetricWidget widget={widget} />
        : <HeroMetricWidget widget={widget} />;  // TODO: crear SecondaryMetricWidget si hace falta
    
    case 'bar':
      return <BarChartWidget widget={widget} />;
    
    case 'line':
      return <LineChartWidget widget={widget} />;
    
    case 'table':
      return <TableWidget widget={widget} />;
    
    case 'pie':
      // TODO: PieChartWidget (futuro)
      return <div className="widget-placeholder">Pie Chart (próximamente)</div>;
    
    default:
      console.warn(`Unknown widget type: ${widget.type}`);
      return (
        <div className="widget-error">
          Tipo de widget no soportado: {widget.type}
        </div>
      );
  }
};

export default ExecutiveWidgetRenderer;
